import { PIPELINE_STAGES } from '../stores/wordStore';
import './StageNav.css';

// Only the generation stages (not status stages like approved/scheduled/etc.).
// The 'new' stage is excluded — new-word entry lives in its own view, not inline
// with the generation pipeline.
const STAGE_STEPS = PIPELINE_STAGES.filter((s) => s.id.startsWith('stage'));

interface StageNavProps {
  currentStage: string;
  completedStages?: Set<string>;
  onNavigate?: (stageId: string) => void;
  staleStages?: Set<string>;
  bgGenerating?: string | null;
  bgReady?: string | null;
}

export default function StageNav({ currentStage, completedStages = new Set(), onNavigate, staleStages = new Set(), bgGenerating = null, bgReady = null }: StageNavProps) {
  return (
    <div className="stage-nav">
      {STAGE_STEPS.map((stage, index) => {
        const isCurrent = stage.id === currentStage;
        const isCompleted = completedStages.has(stage.id);
        const isStale = staleStages.has(stage.id);
        const isGenerating = bgGenerating === stage.id;
        const isBgReady = bgReady === stage.id;
        const isFuture = !isCompleted && !isCurrent;
        const title = isFuture ? `${stage.label} (click to preview — not yet generated)` : stage.label;

        return (
          <div key={stage.id} className="stage-nav-item">
            {index > 0 && <span className="stage-nav-arrow">&rarr;</span>}
            <button
              className={`stage-nav-step ${isCurrent ? 'step-current' : ''} ${isCompleted ? 'step-completed' : ''} ${isFuture ? 'step-future' : ''} ${isStale ? 'step-stale' : ''}${isGenerating ? ' stage-generating' : ''}${isBgReady ? ' stage-bg-ready' : ''}`}
              onClick={() => onNavigate?.(stage.id)}
              title={title}
            >
              <span className="step-dot" style={{ background: isCompleted ? stage.color : undefined }} />
              <span className="step-label">{stage.label.replace(/^Stage \d+[a-z]?: /, '')}</span>
            </button>
          </div>
        );
      })}
    </div>
  );
}
